import React from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import ThermalBackground from '../../molecules/ThermalBackground';
import { useTheme, usePage } from '@contexts';

const StyledLayout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  transition: background-color ${({ theme }) => theme.duration.normal}ms ${({ theme }) => theme.easing.easeOut};
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
`;

const MainContent = styled.main`
  flex: 1;
  padding-top: ${({ isHome }) => (isHome ? '0' : '72px')};
  position: relative;
  width: 100%;
  
  @media (max-width: 768px) {
    padding-top: ${({ isHome }) => (isHome ? '0' : '64px')};
  }
`;

const Layout = ({ children }) => {
  const { currentPage } = usePage();
  const isHome = currentPage === 'home';

  return (
    <StyledLayout isHome={isHome}>
      <ThermalBackground variant={currentPage} />
      {!isHome && <Navbar />}
      <MainContent isHome={isHome}>
        {children}
      </MainContent>
      {!isHome && <Footer />}
    </StyledLayout>
  );
};

export default Layout;